import { useEffect } from "react"
import { useNavigate } from "@tanstack/react-router"
import { toast } from "sonner"
import { parseUnknownError } from "@holigral/shared/api"
import { useLocale } from "@holigral/shared/routing"
import LoadingScreen from "./LoadingScreen"
import { useApplyVerifyEmailMutation } from "@/auth"
import { useT } from "@/i18n"

type Props = {
  params: Record<string, string>
}

// Route has to match profiling_verify_email in the backend, see backend/Security/EmailVerifier.php:48
export default function ApplyVerifyEmail({ params }: Props) {
  const { t } = useT("auth")
  const [applyVerifyEmail] = useApplyVerifyEmailMutation()
  const navigate = useNavigate()
  const locale = useLocale()

  useEffect(() => {
    void (async () => {
      try {
        await applyVerifyEmail(params).unwrap()
        toast.success(t("emailVerified"))
        await navigate({ to: "/$locale", params: { locale }, replace: true })
      } catch (e) {
        const violations = parseUnknownError(e)
        const fallback = t("emailVerifyError")

        toast.error(violations ? (violations[0]?.title ?? fallback) : fallback)
        await navigate({
          to: "/$locale/auth/verify/request",
          params: { locale },
          replace: true,
        })
      }
    })()
  }, [params, applyVerifyEmail, navigate, t, locale])

  return <LoadingScreen />
}
